import React from 'react';

import PropTypes from "prop-types";

import { stateHandler } from './../helpers/state';

const defaultState = {
    usersList:[],
    rootChildList:[],
    carDetails: {},
    selectedCategory: null,
    selectedGroup: null,
    selectedOption: null,
    materialsList:[],
    nodesList:[],
    texturesList:[],
    selectedBodyValue:null,
    currentConfiguration:{},
    configurationsList:[],
    croppingOptionImage:null
}

const CarsStateContext = React.createContext();

const useCarsState = () => {

    const context = React.useContext( CarsStateContext );

    if( context === undefined ) throw new Error('useCarsState must be used within a CarsProvider');

    return context
}

const eventHandlers = {
    //root children
    updateRootChildList: ( __state, action ) => {

        __state.rootChildList = [ ...action.data ];
    },
    addSaveUser: ( __state, action ) => {

        __state.usersList = [ ...__state.usersList ]

        let user = __state.usersList.find( u => u.id == action.data.id );

        if( user ){

            let user_index = __state.usersList.indexOf( user )

            __state.usersList[ user_index ] = { ...user, ...action.data }
        } else {

            __state.usersList = [ { ...action.data }, ...__state.usersList ]
        }
    },
    updateUsersList: ( __state, action ) => {

        __state.usersList = [ ...action.data ];
    },
    //car
    updateCar: ( __state, action ) => {

        if( !__state.carDetails[ action.data.id ] ) __state.carDetails[ action.data.id ] = {};

        if( action.data.user_configurations && action.data.user_configurations.length > 0 ){

            __state.configurationsList = [ ...action.data.user_configurations ];
        }

        if( action.data.users ){

            __state.usersList = [ ...action.data.users ];
        }

        __state.carDetails[ action.data.id ] = { ...__state.carDetails[ action.data.id ], ...action.data };
    },
    addConfiguration: ( __state, action ) => {

        __state.configurationsList = [ { ...action.data }, ...__state.configurationsList ];

        __state.currentConfiguration.id = action.data.id
    },
    saveConfiguration: ( __state, action ) => {

        __state.configurationsList = [ ...__state.configurationsList ];

        let _config = __state.configurationsList.find( c => c.id == action.data.id );

        let _index = __state.configurationsList.indexOf( _config );

        __state.configurationsList[ _index ] = { ...action.data };
    },
    deleteConfiguration: ( __state, action ) => {

        __state.configurationsList = [ ...__state.configurationsList.filter( c => c.id != action.id ) ];
    },
    setCurrentConfiguration: ( __state, action ) => {

        __state.currentConfiguration = { ...action.data, id: action.id }
    },
    setCroppingOptionImage: ( __state, action ) => {
        __state.croppingOptionImage = action.data;
    },
    setSelectedCategory: ( __state, action ) => {

        if( action.data ){

            __state.selectedCategory = { ...action.data };
    
            __state.selectedGroup = { ...action.data.groups[0] };

        } else {

            __state.selectedCategory = null;

            __state.selectedGroup = null;
        }
    },
    setSelectedGroup: ( __state, action ) => {

        __state.selectedGroup = { ...action.data };
    },
    setSelectedOption: ( __state, action ) => {

        __state.currentConfiguration = { ...__state.currentConfiguration }

        if( __state.selectedGroup.select_multiple_options ){
            //if it's multi select
            __state.currentConfiguration[ __state.selectedGroup.slug ] = __state.currentConfiguration[ __state.selectedGroup.slug ] ? 
                [ ...__state.currentConfiguration[ __state.selectedGroup.slug ] ] : 
            [];

            if( __state.currentConfiguration[ __state.selectedGroup.slug ].find( o => o.id == action.data.id ) ){
                //if it is here remove it
                __state.currentConfiguration[ __state.selectedGroup.slug ] = __state.currentConfiguration[ __state.selectedGroup.slug ].filter( o => o.id != action.data.id )
                
            } else {
                //if the option isn't here add it
                __state.currentConfiguration[ __state.selectedGroup.slug ] = [ ...__state.currentConfiguration[ __state.selectedGroup.slug ], { ...action.data } ];
            }
        } else {
            //not multi select
            __state.currentConfiguration[ __state.selectedGroup.slug ] = { ...action.data }
        }

        __state.selectedOption = { ...action.data }
    },
    clearGroupSelection: ( __state, action ) => {

        delete __state.currentConfiguration[ action.group ]
    },
    setMaterialsList: ( __state, action ) => {

        __state.materialsList = [ ...action.materials ]
    },
    updateMaterial: ( __state, action ) => {

        __state.materialsList = [ ...__state.materialsList ];

        let _mat = __state.materialsList.find( m => m.id == action.material.id );

        let _index = __state.materialsList.indexOf( _mat );

        __state.materialsList[ _index ] = { ...action.material };
    },
    setNodesList: ( __state, action ) => {

        __state.nodesList = [ ...action.nodes ]
    },
    setTexturesList: ( __state, action ) => {

        __state.texturesList = [ ...action.textures ]
    },
    addUser: ( __state, action ) => {

        __state.usersList = [ { ...action.data }, ...__state.usersList ];
    },
    updateUser: ( __state, action ) => {

        __state.usersList = [ ...__state.usersList ];

        let _config = __state.usersList.find( c => c.id == action.data.id );

        let _index = __state.usersList.indexOf( _config );

        __state.usersList[ _index ] = { ...action.data };
    },
    deleteUser: ( __state, action ) => {

        __state.usersList = [ ...__state.usersList.filter( c => c.id != action.id ) ];
    },
}

const reducer = ( state, action ) => stateHandler( state, action, eventHandlers );

const CarsProvider = ( { children } ) => {

    const [ state, dispatch ] = React.useReducer(  reducer , defaultState );

    return (
        <CarsStateContext.Provider value={ [ state, dispatch ] }>
            { children }
        </CarsStateContext.Provider>
    )
}

CarsProvider.propTypes = {
    children: PropTypes.oneOfType( [ PropTypes.array, PropTypes.object ] )
}

export { useCarsState, CarsProvider };